export const monedas = ["PESOS", "DOLAR", "EURO"]

// 1. PrimerFormato: 1,000.01 → inglés (US)
export function getMontoPrimerFormato(monto) {
    return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(monto);
}

// 2. SegundoFormato: 1.000,01 → español (Argentina o Europa)
export function getMontoSegundoFormato(monto) {
    return new Intl.NumberFormat("es-AR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(monto);
}

// 3. TercerFormato: 1000.01 → sin separadores, con punto decimal
export function getMontoTercerFormato(monto) {
    return monto.toFixed(2);
}

// 4. CuartoFormato: 1000,01 → sin separadores, con coma decimal
export function getMontoCuartoFormato(monto) {
    return monto.toFixed(2).replace(".", ",");
}

// 5. Convertir número a letras en español
// Ejemplo: 52293187.11 → "Cincuenta y dos millones doscientos noventa y tres mil ciento ochenta y siete con 11/100"
export function getMontoEnLetras(monto) {
    const unidades = ['', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve'];
    const especiales = ['diez', 'once', 'doce', 'trece', 'catorce', 'quince', 'dieciséis', 'diecisiete', 'dieciocho', 'diecinueve'];
    const decenas = ['', '', 'veinte', 'treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa'];
    const centenas = ['', 'ciento', 'doscientos', 'trescientos', 'cuatrocientos', 'quinientos', 'seiscientos', 'setecientos', 'ochocientos', 'novecientos'];

    const convertirGrupo = (n) => {
        if (n === 0) return '';
        if (n === 100) return 'cien';

        let resultado = '';

        // Centenas
        if (n >= 100) {
            resultado += centenas[Math.floor(n / 100)] + ' ';
            n = n % 100;
        }

        // Decenas y unidades
        if (n >= 10 && n <= 19) {
            resultado += especiales[n - 10];
        } else if (n >= 20 && n <= 29) {
            if (n === 20) {
                resultado += 'veinte';
            } else {
                resultado += 'veinti' + unidades[n - 20];
            }
        } else if (n >= 30) {
            resultado += decenas[Math.floor(n / 10)];
            if (n % 10 !== 0) {
                resultado += ' y ' + unidades[n % 10];
            }
        } else if (n > 0) {
            resultado += unidades[n];
        }

        return resultado.trim();
    };

    const convertirNumero = (num) => {
        if (num === 0) return 'cero';
        if (num < 0) return 'menos ' + convertirNumero(-num);

        let resultado = '';

        // Millones
        if (num >= 1000000) {
            const millones = Math.floor(num / 1000000);
            if (millones === 1) {
                resultado += 'un millón ';
            } else {
                resultado += convertirGrupo(millones) + ' millones ';
            }
            num = num % 1000000;
        }

        // Miles
        if (num >= 1000) {
            const miles = Math.floor(num / 1000);
            if (miles === 1) {
                resultado += 'mil ';
            } else {
                resultado += convertirGrupo(miles) + ' mil ';
            }
            num = num % 1000;
        }

        // Resto (centenas, decenas, unidades)
        if (num > 0) {
            resultado += convertirGrupo(num);
        }

        return resultado.trim();
    };

    // Separar parte entera y decimal
    const partes = monto.toFixed(2).split('.');
    const parteEntera = parseInt(partes[0], 10);
    const parteDecimal = partes[1];

    // Capitalizar primera letra
    let letras = convertirNumero(parteEntera);
    letras = letras.charAt(0).toUpperCase() + letras.slice(1);

    return `${letras} con ${parteDecimal}/100`;
}